export type Language = 'en' | 'id' | 'fr' | 'zh_CN' | 'zh_TW' | 'es' | 'th';

/** Headline plus one supporting sentence, the shape of every home page pillar. */
export interface PillarCopy {
  title: string;
  desc: string;
}

export interface TranslationKeys {
  nav: {
    home: string;
    more: string;
    close: string;
    blockExplorer: string;
    docs: string;
    swap: string;
    exchange: string;
    bridge: string;
  };
  bridge: {
    title: string;
    subtitle: string;
    tabDeposit: string;
    tabDepositSub: string;
    tabWithdraw: string;
    tabWithdrawSub: string;
    chainKaspa: string;
    chainEvm: string;
    useWallet: string;
    gate: {
      installTitle: string;
      installDesc: string;
      disconnectedTitle: string;
      connectWallet: string;
      connectTitle: string;
      connectDesc: string;
      connecting: string;
      connectChain: string;
    };
    deposit: {
      youSend: string;
      youReceive: string;
      recipientLabel: string;
      fromWallet: string;
      badAddress: string;
      connectEvm: string;
      connectingEvm: string;
      infoMin: string;
      infoMining: string;
      infoMint: string;
      phaseConnecting: string;
      phaseFetching: string;
      phaseMining: string;
      phaseSigning: string;
      phaseBroadcasting: string;
      cancelMining: string;
      successTitle: string;
      successMined: string;
      kaspaTx: string;
      prefixWarning: string;
      newDeposit: string;
      cta: string;
      ctaAmount: string;
    };
    withdraw: {
      youBurn: string;
      paidOut: string;
      payoutLabel: string;
      infoLimits: string;
      infoFeeZero: string;
      infoFeeQuoted: string;
      infoRate: string;
      warningPrefix: string;
      warningStrong: string;
      warningRest: string;
      checking: string;
      modalTitle: string;
      modalBurn: string;
      modalFee: string;
      modalPayout: string;
      modalAck: string;
      modalConfirm: string;
      modalBack: string;
      successTitle: string;
      requestId: string;
      igraTx: string;
      successPayout: string;
      successNote: string;
      newWithdrawal: string;
      requesting: string;
      cta: string;
      ctaAmount: string;
    };
  };
  home: {
    tagline: string;
    hero: {
      subtitle: string;
      chainsLabel: string;
      ctaDownload: string;
      ctaTelegram: string;
      note: string;
    };
    /** The four traits the wallet is positioned on, one card each. */
    pillars: {
      security: PillarCopy;
      convenience: PillarCopy;
      friendly: PillarCopy;
      reliable: PillarCopy;
    };
    content: {
      downloadTitle: string;
      securityTitle: string;
      p1: string;
      p2: string;
      p3: string;
    };
  };
  about: {
    contact: string;
    contacts: {
      twitter: string;
      telegram: string;
      discord: string;
      email: string;
    };
  };
  footer: {
    privacy: string;
    copyright: string;
  };
  explorer: {
    title: string;
    subtitle: string;
    timeRange: string;
    to: string;
    clear: string;
    address: string;
    kasTab: string;
    krc20Tab: string;
    enterAddress: string;
    loading: string;
    search: {
      placeholder: string;
      button: string;
    };
    tx: {
      loading: string;
      empty: string;
      emptyInRange: string;
      failed: string;
      retry: string;
    };
    krc20: {
      loading: string;
      empty: string;
      emptyInRange: string;
      failed: string;
      retry: string;
    };
  };
  languageNames: Record<Language, string>;
}

export const LANGUAGE_NAMES: Record<Language, string> = {
  en: 'EN',
  id: 'ID',
  fr: 'FR',
  zh_CN: '简体中文',
  zh_TW: '繁體中文',
  es: 'ES',
  th: 'TH',
};

export const SUPPORTED_LANGUAGES: Language[] = ['en', 'id', 'fr', 'zh_CN', 'zh_TW', 'es', 'th'];
